export default __webpack_public_path__ + "static/media/Cord1.b871c6e0.png";